<template>
  <div>
    <div class="sub-container">
      <div class="contact-header">
        <el-radio-group v-model="orderType">
          <el-radio-button label="0">开方订单</el-radio-button>
          <el-radio-button label="1">配送订单</el-radio-button>
        </el-radio-group>
        <div class="search-right">
          <el-date-picker
            prefix-icon="none"
            v-model="orderMonth"
            @change="datePickerChange"
            value-format="yyyy-MM"
            align="center"
            type="month"
            placeholder="选择订单月份"
          >
          </el-date-picker>
          <el-input
            class="input-circle"
            v-model="searchText"
            placeholder="患者姓名或手机号码"
          ></el-input>
          <el-button
            class="button-search"
            round
            @click="search"
            size="mini"
            >搜 索</el-button
          >
        </div>
      </div>
      <el-tabs
        class="tabs"
        type="card"
        v-if="orderType == 0"
        v-model="activeName1"
        @tab-click="handleClick"
      >
        <el-tab-pane label="全部" name="-1"></el-tab-pane>
        <el-tab-pane label="待付款" name="0"></el-tab-pane>
        <el-tab-pane label="已完成" name="1"></el-tab-pane>
        <el-tab-pane label="已取消" name="2"></el-tab-pane>
      </el-tabs>
      <el-tabs
        class="tabs"
        type="card"
        v-if="orderType == 1"
        v-model="activeName2"
        @tab-click="handleFulClick"
      >
        <el-tab-pane label="全部" name="-1"></el-tab-pane>
        <el-tab-pane label="草稿" name="100"></el-tab-pane>
        <el-tab-pane label="待付款" name="0"></el-tab-pane>
        <el-tab-pane label="待收货" name="1"></el-tab-pane>
        <el-tab-pane label="已完成" name="2"></el-tab-pane>
        <el-tab-pane label="已取消" name="3"></el-tab-pane>
      </el-tabs>
      <el-table
        class="order-table"
        :data="currentOrderList"
        @row-click="tableClick"
        style="width: 100%"
        :border="tableBorder"
        v-show="orderType == '0' && currentOrderList.length > 0"
      >
        <el-table-column
          prop="typeText"
          align="left"
          label="开方类型"
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          prop="patientName"
          align="left"
          label="病人名称"
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          prop="patientPhoneNo"
          label="手机号"
          align="left"
          min-width="200"
        >
        </el-table-column>
        <el-table-column
          prop="createTimeString"
          label="下单时间"
          align="left"
          min-width="220"
        >
        </el-table-column>
        <el-table-column prop="price" label="订单价格" align="left" min-width="160">
        </el-table-column>
        <el-table-column
          prop="statusDesc"
          label="订单状态"
          align="left"
          min-width="120"
        >
        </el-table-column>
        <!-- <el-table-column fixed="right" label="" align='center' width="0">
          <template slot-scope="scope">
              <el-popover
                v-show="showPopver"
                placement="bottom"
                trigger="click"
                width="300">
                <p style="font-size: 16px;">请选择支付方式:</p>
                <el-form class="pay-form">
                  <WJTRadio
                      v-model="currentOrderList[scope.$index].payType.value"
                      :label="currentOrderList[scope.$index].payType.key"
                      :radios='currentOrderList[scope.$index].payType.options'>
                  </WJTRadio>
                </el-form>
                <div style="background-color: #E6E6E6; height: 0.5px; width: 100%; position: relative; bottom: 5px;"></div>
                <div style="text-align: center; margin: 0">
                  <el-button style="height: 35px; font-size: 18px;margin-top: 6px;" type="text" size="mini" @click="pay(scope.$index)">确定</el-button>
                </div>
                <el-button type="primary" slot="reference" size="small" v-show="currentOrderList[scope.$index].status == '0'">
                  重新支付
                </el-button>
              </el-popover>
              <el-button type="primary" slot="reference" size="small" @click="pay(scope.$index)" v-show="false">
                重新支付
              </el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        v-if="orderType == '0' && totalPage > 10"
        class="pagination"
        background
        layout="prev, pager, next"
        :current-page="currentPageNo"
        @current-change="pageChange"
        :total="totalPage"
      >
      </el-pagination>
      <div
        class="empty-container"
        v-if="orderType == '0' && currentOrderList.length == 0"
      >
        <span>{{ emptyText }}</span>
      </div>

      <el-table
        class="order-table"
        :data="currentFulOrderList"
        @row-click="tableFulClick"
        style="width: 100%"
        :border="tableFulBorder"
        v-show="
          orderType == '1' &&
          currentFulOrderList.length > 0 &&
          activeName2 != '100'
        "
      >
        <el-table-column
          prop="patientName"
          align="left"
          label="病人名称"
          min-width="90"
        >
        </el-table-column>
        <el-table-column
          prop="patientPhoneNo"
          label="手机号"
          align="left"
          min-width="130"
        >
        </el-table-column>
        <el-table-column
          prop="deliveryOrderId"
          label="订单号"
          align="left"
          min-width="210"
        >
        </el-table-column>
        <el-table-column
          prop="typeText"
          label="处方类型"
          align="left"
          min-width="110"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="下单时间"
          align="left"
          min-width="180"
        >
        </el-table-column>
        <el-table-column
          prop="deliveryName"
          label="配送中心"
          align="left"
          min-width="200"
        >
        </el-table-column>
        <el-table-column
          prop="sumPrice"
          label="价格(元)"
          align="left"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="statusText"
          label="订单状态"
          align="left"
          min-width="90"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="orderType == '1' && totalFulPage > 10 && activeName2 != '100'"
        class="pagination"
        background
        layout="prev, pager, next"
        :current-page="currentFulPageNo"
        @current-change="pageFulChange"
        :total="totalFulPage"
      >
      </el-pagination>

      <div
        class="empty-container"
        v-show="
          orderType == '1' &&
          currentFulOrderList.length == 0 &&
          activeName2 != '100'
        "
      >
        <span>{{ emptyText }}</span>
      </div>

      <el-table
        class="order-table"
        :data="currentDraftList"
        @row-click="tableDraftClick"
        style="width: 100%"
        :border="tableDraftBorder"
        v-show="
          orderType == '1' &&
          currentDraftList.length > 0 &&
          activeName2 == '100'
        "
      >
        <el-table-column
          prop="recipientName"
          align="left"
          label="病人名称"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="recipientPhone"
          label="手机号"
          align="left"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          prop="visitRecordId"
          label="开方订单号"
          align="left"
          min-width="220"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="保存时间"
          align="left"
          min-width="180"
        >
        </el-table-column>
        <el-table-column
          prop="recipientAddress"
          label="配送地址"
          align="left"
          min-width="435"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="orderType == '1' && totalDraftPage > 10 && activeName2 == '100'"
        class="pagination"
        background
        layout="prev, pager, next"
        :current-page="currentDraftPageNo"
        @current-change="pageDraftChange"
        :total="totalDraftPage"
      >
      </el-pagination>

      <div
        class="empty-container"
        v-show="
          orderType == '1' &&
          currentDraftList.length == 0 &&
          activeName2 == '100'
        "
      >
        <span>{{ emptyText }}</span>
      </div>
    </div>
    <el-dialog
      title="微信支付"
      :visible.sync="qrcodeVisble"
      width="360px"
      :close-on-click-modal="dialogClosable"
    >
      <div class="dialog-wrapper">
        <div id="qrcode"></div>
        <span class="qrcode-dialog-text"
          >二维码过期了？<b @click="qrcodeRefresh">立即刷新</b></span
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
let un_pay_status = "0"; //未支付
let payed_status = "1"; //已支付
let order_avaliable_status = "2"; //订单生效
let prescripting_status = "3"; //配药中
let expressing_status = "4"; //配送中
let express_complete_status = "5"; //配送完成
import WJTRadio from "@/components/widgets/wjt-radio.vue";
import QRCode from "qrcodejs2";
export default {
  name: "orderList",
  components: {
    WJTRadio,
  },
  data() {
    return {
      currentOrderList: [],
      currentFulOrderList: [],
      activeName1: "-1",
      activeName2: "-1",
      orderType: "0", //0:开方  1：配送
      orderMonth: "",
      tableBorder: false,
      tableFulBorder: false,
      tableDraftBorder: false,
      currentPageNo: 1,
      currentFulPageNo: 1,
      currentDraftPageNo: 1,
      pageSize: 12,
      pageFulSize: 12,
      pageDraftSize: 12,
      totalPage: 1,
      totalFulPage: 1,
      totalDraftPage: 1,
      searchText: "",
      emptyText: "您还没有订单",
      editable: false,
      confirmLoading: false,
      payType: {
        key: "",
        value: "微信支付",
        options: ["公共账户", "微信支付"],
      },
      qrcodeVisble: false,
      outTradeNo: "",
      currentIndex: 0,
      dialogClosable: false,
      showPopver: false,
      isSearch: false,
      currentDraftList: [],
    };
  },
  created() {
    console.log("order created");
    var data = this.$store.getters.getOrderData;
    console.log(data);
    if (!this.utils.isEmptyObject(data)) {
      this.activeName1 = data.activeName1;
      this.activeName2 = data.activeName2;
      this.orderType = data.orderType;
      this.orderMonth = data.orderMonth;
      this.currentPageNo = data.currentPageNo;
      this.currentFulPageNo = data.currentFulPageNo;
      this.currentDraftPageNo = data.currentDraftPageNo;
      this.pageSize = data.pageSize;
      this.pageFulSize = data.pageFulSize;
      this.pageDraftSize = data.pageDraftSize;
      this.totalPage = data.totalPage;
      this.totalFulPage = data.totalFulPage;
      this.totalDraftPage = data.totalDraftPage;
      this.searchText = data.searchText;
      this.currentIndex = data.currentIndex;
      this.isSearch = data.isSearch;
    }
    var userInfo = this.$store.getters.getUserInfo;
    console.log(userInfo);
    if (!this.utils.isEmptyObject(userInfo)) {
      if (userInfo.doctor && userInfo.doctor.hospitalId == 101) {
        this.showPopver = false;
      } else {
        this.showPopver = true;
      }
    }
    if (this.orderType == "0") {
      this.getOrderList();
    } else if (this.activeName2 == "100") {
      this.getDraftList();
    } else {
      this.getFulOrderList();
    }
  },
  methods: {
    search() {
      this.isSearch = true;
      if (this.orderType == "0") {
        this.currentPageNo = 1;
        this.getOrderList();
      } else {
        this.currentFulPageNo = 1;
        this.getFulOrderList();
      }
    },
    getOrderList() {
      var params = {};
      if (this.activeName1 == "-1") {
        params = {
          pageNum: this.currentPageNo,
          pageSize: this.pageSize,
          keyWord: this.isSearch ? this.searchText : "",
          createTimeString: this.orderMonth,
        };
      } else {
        params = {
          createTimeString: this.orderMonth,
          pageNum: this.currentPageNo,
          pageSize: this.pageSize,
          status: this.activeName1 == "-1" ? "" : this.activeName1,
          keyWord: this.isSearch ? this.searchText : "",
        };
      }

      this.wjtHttp.get(
        this,
        "/api/health/v1/prescription/order",
        params,
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            var orderList = data.rows;
            this.currentOrderList = orderList;
            if (!this.utils.isEmptyStr(orderList)) {
              this.totalPage = Math.ceil(data.total / 12) * 10;
              for (var i = 0; i < orderList.length; i++) {
                orderList[i].typeText = [];
                // orderList[i].prescriptionType == "S"
                //   ? "自拟组方"
                //   : "智能开方";
                // if (orderList[i].prescriptionType == "R") {
                //   orderList[i].typeText = "私人订制茶";
                // }if (orderList[i].prescriptionType == "Z") {
                //   orderList[i].typeText = "公共自拟方";
                // } else if (orderList[i].prescriptionType == "S") {
                //   orderList[i].typeText = "自拟组方";
                // } else {
                //   orderList[i].typeText = "智能开方";
                // }
                orderList[i].typeText=orderList[i].prescriptionTypeString
                if (this.showPopver) {
                  orderList[i].payType = {
                    key: "",
                    value: "微信支付",
                    options: ["公共账户", "微信支付"],
                  };
                } else {
                  orderList[i].payType = {
                    key: "",
                    value: "微信支付",
                    options: ["微信支付"],
                  };
                }
              }
            } else if (this.currentPageNo == 1) {
              this.emptyText = "您当月没有订单";
              this.totalPage = 1;
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "订单服务异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getFulOrderList() {
      var status = "";
      if (this.activeName2 == "0") {
        status = un_pay_status;
      } else if (this.activeName2 == "1") {
        status =
          payed_status +
          "_" +
          order_avaliable_status +
          "_" +
          prescripting_status +
          "_" +
          expressing_status;
      } else if (this.activeName2 == "2") {
        status = express_complete_status;
      } else if (this.activeName2 == "3") {
        status = "-1_-2_-3_-4_-5_-6";
      } else if (this.activeName2 == "-1") {
        status = "0_1_2_3_4_5_-1_-2_-3_-4_-5_-6";
      }
      this.wjtHttp.get(
        this,
        "/api/delivery/order/list",
        {
          pageNum: this.currentFulPageNo,
          pageSize: this.pageFulSize,
          status: status,
          patientName: this.isSearch ? this.searchText : "",
          queryMonth: this.orderMonth,
        },
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            var orderList = data.rows;
            this.currentFulOrderList = orderList;
            if (!this.utils.isEmptyStr(orderList)) {
              this.totalFulPage = Math.ceil(data.total / 12) * 10;
            } else if (this.currentFulPageNo == 1) {
              this.emptyText = "您当月没有订单";
              this.totalFulPage = 1;
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "订单服务异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getDraftList() {
      this.wjtHttp.get(
        this,
        "/api/delivery/order/draft/list",
        {
          pageNum: this.currentDraftPageNo,
          pageSize: this.pageDraftSize,
          patientPhoneNo: this.isSearch ? this.searchText : "",
          queryMonth: this.orderMonth,
        },
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            var draftList = data.rows;
            this.currentDraftList = draftList;
            if (!this.utils.isEmptyStr(draftList)) {
              this.totalDraftPage = Math.ceil(data.total / 12) * 10;
            } else if (this.currentDraftPageNo == 1) {
              this.emptyText = "您当月没有草稿";
              this.totalDraftPage = 1;
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "获取草稿异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    handleClick() {
      this.currentPageNo = 1;
      this.searchText = "";
      this.isSearch = false;
      this.getOrderList();
    },
    handleFulClick() {
      this.currentFulPageNo = 1;
      this.searchText = "";
      this.isSearch = false;
      if (this.activeName2 == "100") {
        this.getDraftList();
      } else {
        this.getFulOrderList();
      }
    },
    pageChange(pageNo) {
      this.currentPageNo = pageNo;
      this.getOrderList();
    },
    pageFulChange(pageNo) {
      this.currentFulPageNo = pageNo;
      this.getFulOrderList();
    },
    pageDraftChange(pageNo) {
      this.currentDraftPageNo = pageNo;
      this.getDraftList();
    },
    isUserTypeByValue(roles, val) {
      for (var i = 0; i < roles.length; i++) {
        var value = roles[i];
        if (value == val) {
          return true;
        }
      }
      return false;
    },
    tableClick(row, column, event) {
      // var userInfo = this.$store.getters.getUserInfo;
      // var roles = userInfo.roles;
      // if (this.isUserTypeByValue(roles, "common_doctor")) {
      //   this.$router.push({
      //       path: "/commonHandmadePrescriptionDetails",
      //       query: {
      //         visitRecordId: row.visitRecordId,
      //         patientId: row.patientId,
      //         prescriptionType: row.prescriptionType,
      //       },
      //     });
      //     return
      // }

      if (row.status == "1") {
        if (row.prescriptionType == "G") {
          this.$router.push({
            path: "/GeneralPrescription",
            query: {
              visitRecordId: row.visitRecordId,
              patientId: row.patientId,
              prescriptionType: row.prescriptionType,
            },
          });
        } else if (row.prescriptionType == "R") {
          this.$router.push({
            path: "/CUSTOMIZEDPrescription",
            query: {
              visitRecordId: row.visitRecordId,
              patientId: row.patientId,
              prescriptionType: row.prescriptionType,
            },
          });
        } else if (row.prescriptionType == "Z") {
          this.$router.push({
            path: "/commonHandmadePrescriptionDetails",
            query: {
              visitRecordId: row.visitRecordId,
              patientId: row.patientId,
              prescriptionType: row.prescriptionType,
            },
          });
        } else if (row.prescriptionType == "B") {
          sessionStorage.setItem("visitRecordId", row.visitRecordId);
          this.$router.push({
            path: "/chaoweiPrescription",
            query: {
              visitRecordId: row.visitRecordId,
              patientId: row.patientId,
              prescriptionType: row.prescriptionType,
            },
          });
        } else {
          this.$router.push({
            path: "/prescription",
            query: {
              visitRecordId: row.visitRecordId,
              patientId: row.patientId,
              prescriptionType: row.prescriptionType,
            },
          });
        }
      }
    },
    tableFulClick(row, column, event) {
      if (row.form == "R") {
        this.$router.push({
          path: "/CUSTOMIZEDfulfillmentOrder",
          query: {
            orderId: row.deliveryOrderId,
          },
        });
      } else {
        this.$router.push({
          path: "/fulfillmentOrder",
          query: {
            orderId: row.deliveryOrderId,
          },
        });
      }
    },
    tableDraftClick(row, column, event) {
      var userInfo = this.$store.getters.getUserInfo;
      var roles = userInfo && userInfo.roles ? userInfo.roles : [];
      var isAgentDemo = false;
      for (var i = 0; i < roles.length; i++) {
        if (roles[i] == "level1" || roles[i] == "level2") {
          isAgentDemo = true;
          break;
        }
      }
      if (isAgentDemo) {
        this.$message.warning("当前为演示账号，配送下单功能暂未开放");
        return;
      }
      sessionStorage.setItem(
        "prescription",
        JSON.stringify({
          endDate: row.endDate,
          startDate: row.startDate,
          type: row.type,
          visitRecordId: row.visitRecordId,
        })
      );
      this.$router.push({
        path: "/fulfillmentConfirm",
        query: {
          mode: 1,
        },
      });
    },
    datePickerChange(value) {
      this.orderMonth = value;
      this.currentPageNo = 1;
      this.isSearch = false;
      if (this.orderType == "0") {
        this.getOrderList();
      } else {
        this.getFulOrderList();
      }
    },
    pay(index) {
      if (this.mInterval) {
        clearInterval(this.mInterval);
      }
      this.currentIndex = index;
      var order = this.currentOrderList[index];
      var params = {
        productId: order.visitRecordId,
        orderType: 1,
        tradeType: "NATIVE",
        payChannel: order.payType.value == "微信支付" ? "1" : "3",
      };
      this.wjtHttp.post(
        this,
        "/api/api/pay/0.1/unifiedOrder",
        params,
        false,
        (res) => {
          var data = res.data;
          this.payLoading = false;
          if (data.code == 200) {
            if (
              data.data.payChannel == 1 &&
              !this.utils.isEmptyStr(data.data.qrcode)
            ) {
              this.qrcodeVisble = true;
              this.outTradeNo = data.data.outTradeNo;
              this.$nextTick(() => {
                if (this.mQrCode != undefined && this.mQrCode != null) {
                  this.mQrCode.clear();
                  this.mQrCode.makeCode(data.data.qrcode);
                } else {
                  this.mQrCode = new QRCode("qrcode", {
                    text: data.data.qrcode,
                    width: 256,
                    height: 256,
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                    correctLevel: QRCode.CorrectLevel.H,
                  });
                }
                this.getPayStatus();
              });
            } else {
              this.$message({
                message: "支付成功",
                type: "success",
              });
              this.getOrderList();
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "支付异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
          this.payLoading = false;
        }
      );
    },
    qrcodeRefresh() {
      this.pay(this.currentIndex);
    },
    getPayStatus() {
      if (this.mInterval != undefined && this.mInterval != null) {
        clearInterval(this.mInterval);
      }
      this.mInterval = setInterval(() => {
        var params = {
          outTradeNo: this.outTradeNo,
        };
        this.wjtHttp.post(
          this,
          "/api/api/pay/0.1/query/place/result",
          params,
          false,
          (res) => {
            var data = res.data;
            if (data.code == 200) {
              if (data.data == 1103) {
                this.$message({
                  message: "支付成功",
                  type: "success",
                });
                this.qrcodeVisble = false;
                this.getOrderList();
                clearInterval(this.mInterval);
              }
            }
          },
          (err) => {
            console.log(err);
          }
        );
      }, 3000);
    },
  },
  beforeDestroy() {
    if (this.mInterval) {
      clearInterval(this.mInterval);
    }
    console.log("order beforeDestroy");
    this.$store.commit("updateOrderData", {
      activeName1: this.activeName1,
      activeName2: this.activeName2,
      orderType: this.orderType, //0:开方  1：配送
      orderMonth: this.orderMonth,
      currentPageNo: this.currentPageNo,
      currentFulPageNo: this.currentFulPageNo,
      currentDraftPageNo: this.currentDraftPageNo,
      pageSize: this.pageSize,
      pageFulSize: this.pageFulSize,
      pageDraftSize: this.pageDraftSize,
      totalPage: this.totalPage,
      totalFulPage: this.totalFulPage,
      totalDraftPage: this.totalDraftPage,
      searchText: this.searchText,
      currentIndex: this.currentIndex,
      isSearch: this.isSearch,
    });
  },
  beforeRouteLeave(to, from, next) {
    console.log(to);
    if (to.name != "Prescription" && to.name != "fulfillmentOrder") {
      this.$store.commit("updateOrderData", {});
    }
    next();
  },
  watch: {
    searchText: function (val) {
      if (this.utils.isEmptyStr(val)) {
        this.currentPageNo = 1;
        this.isSearch = false;
        if (this.orderType == "0") {
          this.getOrderList();
        } else if (this.activeName2 == "100") {
          this.getDraftList();
        } else {
          this.getFulOrderList();
        }
      }
    },
    orderType: function (val) {
      this.isSearch = false;
      this.searchText = "";
      if (val == "0") {
        this.getOrderList();
      } else if (this.activeName2 == "100") {
        this.getDraftList();
      } else {
        this.getFulOrderList();
      }
    },
  },
};
</script>

<style scoped>
.sub-container {
  width: 1160px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-height: 70vh;
  padding-bottom: 100px;
}

.contact-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #f9fafb;
  width: 100%;
  border-radius: 14px;
  margin-bottom: 20px;
  gap: 16px;
}
.search-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}

/* 订单类型切换按钮组绿色主题 */
.contact-header >>> .el-radio-button__inner {
  border-color: #20863F;
  color: #20863F;
  border-radius: 12px !important;
  padding: 10px 22px;
  font-weight: 700;
  box-shadow: none !important;
  transition: all 0.2s;
  margin-right: 10px;
}
.contact-header >>> .el-radio-button.is-active .el-radio-button__inner {
  background-color: #20863F;
  border-color: #20863F;
  color: #fff;
  box-shadow: -1px 0 0 0 #20863F !important;
}

/* 日期选择器 */
.contact-header >>> .el-date-editor.el-input,
.contact-header >>> .el-date-editor.el-input__inner {
  width: 180px;
  height: 40px;
  border-radius: 10px;
}
.contact-header >>> .el-input__inner {
  border-radius: 10px;
  border-color: #e2e8f0;
}
.contact-header >>> .el-input__inner:focus,
.contact-header >>> .el-date-editor .el-input__inner:focus {
  border-color: #20863F;
}

.input-circle {
  width: 260px;
  height: 40px;
}
.input-circle >>> input {
  border-radius: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border-color: #e2e8f0;
}
.input-circle >>> input:focus {
  border-color: #20863F;
}

.button-search {
  height: 40px;
  width: 100px;
  background-color: #20863F;
  border-color: #20863F;
  color: #fff;
  font-weight: 600;
}
.button-search:hover {
  background-color: #257648;
  border-color: #257648;
  color: #fff;
}

.tabs {
  width: 100%;
  padding-left: 10px;
  margin-bottom: 8px;
}
/* tab 绿色主题 */
.tabs >>> .el-tabs__item.is-active {
  color: #20863F;
}
.tabs >>> .el-tabs__item:hover {
  color: #20863F;
}
.tabs >>> .el-tabs__active-bar {
  background-color: #20863F;
}
.tabs >>> .el-tabs__header {
  border-bottom-color: #e2e8f0;
}

.divider {
  width: 100%;
  background: #eeeeee;
  height: 1px;
}

.pagination {
  margin-top: 20px;
  margin-bottom: 10px;
  align-self: center;
}
.order-table {
  width: 100% !important;
}

.empty-container {
  width: 100%;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-container > span {
  font-size: 20px;
  color: #aeaeae;
}

.contact-dialog {
  border-radius: 10px;
}

.radio-button-one {
  margin-right: 50px;
}

.dialog-picker {
  width: 350px;
}

.address-picker1 {
  width: 350px;
}

.address-picker2 {
  width: 350px;
}

.dialog-form {
  width: 450px;
}

.dialog-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.btn-dialog-cancel {
  margin-right: 50px;
  width: 150px;
  border-radius: 30px;
  margin-top: 30px;
  border-color: #20863F;
  color: #20863F;
}
.btn-dialog-cancel:hover {
  background-color: #f3fbf6;
  border-color: #20863F;
  color: #20863F;
}

.btn-dialog-confirm {
  margin-left: 50px;
  width: 150px;
  border-radius: 30px;
  margin-top: 30px;
  background-color: #20863F;
  border-color: #20863F;
  color: #fff;
}
.btn-dialog-confirm:hover {
  background-color: #257648;
  border-color: #257648;
  color: #fff;
}

.qrcode-dialog-text {
  color: #333333;
  font-size: 20px;
  margin-top: 30px;
}
.qrcode-dialog-text > b {
  color: #20863F;
  font-size: 20px;
  cursor: pointer;
}
.pay-form {
  position: relative;
  left: 174px;
  margin-top: 26px;
}

/* 订单表格绿色主题 */
.order-table {
  border: 1px solid #d3e6d8;
  border-radius: 14px;
  overflow: hidden;
}
.order-table >>> .el-table {
  border: 1px solid #d3e6d8;
  border-radius: 14px;
  overflow: hidden;
}
.order-table >>> .el-table__header-wrapper,
.order-table >>> .el-table__body-wrapper {
  border-radius: 14px;
  overflow: hidden;
}
.order-table >>> .el-table__header thead tr:first-child th:first-child {
  border-top-left-radius: 14px;
}
.order-table >>> .el-table__header thead tr:first-child th:last-child {
  border-top-right-radius: 14px;
}
.order-table >>> .el-table__body tbody tr:last-child td:first-child,
.order-table >>> .el-table__body tbody tr:last-child td:first-child .cell {
  border-bottom-left-radius: 14px;
}
.order-table >>> .el-table__body tbody tr:last-child td:last-child,
.order-table >>> .el-table__body tbody tr:last-child td:last-child .cell {
  border-bottom-right-radius: 14px;
}
.order-table >>> .el-table--border {
  border-color: #d3e6d8;
}
.order-table >>> .el-table--border th.el-table__cell,
.order-table >>> .el-table--border td.el-table__cell {
  border-color: #d3e6d8;
}
.order-table >>> th.el-table__cell {
  background: #20863F !important;
  color: #fff !important;
  font-weight: 700 !important;
}
.order-table >>> td.el-table__cell {
  color: #385846;
}
.order-table >>> .el-table__row:hover > td.el-table__cell {
  background-color: #f3fbf6 !important;
}
</style>
